/* eslint-disable react-hooks/exhaustive-deps */
import dayjs from 'dayjs';
import moment from 'moment';
import { Fragment, useEffect, useRef, useState } from 'react';
import { Chip, Divider, Fade, FormControl, FormControlLabel, Grow, MenuItem, OutlinedInput, Radio, RadioGroup, Select, Stack, TextField, useMediaQuery, useTheme } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import Question from '../../Question/Question';
import Label from '../../Label/Label';
import Error from '../../Error/Error';
import { DatePicker } from '@mui/x-date-pickers';
import { changeCurrentErrorMessage, changeIsButtonEnabled, changeStepsDataEmprunteur } from '../../../redux/actions';
import { RiEditBoxLine } from 'react-icons/ri';
import { PiBankLight } from 'react-icons/pi';
import colors from '../../../colors/colors';
import GooglePlacesAutocomplete from 'react-google-places-autocomplete';
import '../ParcoursEmprunteur.scss';


const questions = [
    <Fragment>
        <p style={{ fontSize: 16 }}>
            Nous avons besoin de confirmer certaines informations et d'autres informations complémentaires.
        </p>
    </Fragment>,
    <Fragment>
        <p style={{ fontSize: 16 }} >
            Vous serez débité le premier jour de votre couverture, uniquement si vous finalisez votre souscription.
        </p>
    </Fragment>
];


const phoneNumberRegex = new RegExp(`^(0|(00|\\+)33)[123456789][0-9]{8}$`);
const emailRegEx = new RegExp('[A-Za-z0-9._%-]+@[A-Za-z0-9._%-]+\\.[a-z]{2,3}');


export default function InfosComplementaires() {
    const theme = useTheme();
    const dispatch = useDispatch();

    const stepEmprunteur = useSelector((store: any) => store.stepEmprunteur.stepEmprunteur);
    const currentSubstep = useSelector((store: any) => store.currentSubstep.currentSubstep);
    const initDataEmprunteur = useSelector((store: any) => store.initDataEmprunteur.initDataEmprunteur);
    const stepsDataEmprunteur = useSelector((store: any) => store.stepsDataEmprunteur.stepsDataEmprunteur);
    const currentErreurMessage = useSelector((store: any) => store.currentErreurMessage.currentErreurMessage);

    const [data, setData] = useState<any>(stepsDataEmprunteur["informations-complementaires"]);
    const [dataAdherents, setDataAdherents] = useState<any>(stepsDataEmprunteur["informations-complementaires"]["lst_adherents"]);
    const [activeAdherent, setActiveAdherent] = useState<number>(0);
    const [activeRib, setActiveRib] = useState<number>();

    const activeAdherentRef = useRef(activeAdherent);
    const activeRibRef = useRef(activeRib);

    const [lstPays] = useState<any>(initDataEmprunteur["lst_pays"]);
    const [lstProfession] = useState<any>(initDataEmprunteur["lst_profession"]);
    const [lstTypeRib] = useState<any>(initDataEmprunteur["lst_rib"]);
    const [lstFormeJuridique] = useState<any>(initDataEmprunteur["lst_forme_juridique"]);

    const matches = useMediaQuery(theme.breakpoints.down('md'));

    useEffect(() => {
        window.scroll(0, 0);
        dispatch(changeIsButtonEnabled(false));
        const inputAdresseAdherent = document.querySelector('.google-places-autocomplete__input');
        const inputAdresseRib = document.querySelector('.rib-adresse-autocomplete__input');
        if (inputAdresseAdherent) {
            inputAdresseAdherent.addEventListener('input', (event: any) => {
                handleAdresseAdherent(activeAdherentRef.current, { adresse: event.target.value });
            });
        }
        if (inputAdresseRib) {
            inputAdresseRib.addEventListener('input', (event: any) => {
                handleDataRib(activeRibRef.current as number, "adresse", event.target.value);
            });
        }
        return () => {
            dispatch(changeCurrentErrorMessage(currentErreurMessage ?? null));
            dispatch(changeIsButtonEnabled(false));
            if (inputAdresseAdherent) {
                inputAdresseAdherent.removeEventListener('input', handleAdresseAdherent as unknown as EventListener);
            }
            if (inputAdresseRib) {
                inputAdresseRib.removeEventListener('input', handleDataRib as unknown as EventListener);
            }
        }
    }, []);

    useEffect(() => {
        dispatch(changeStepsDataEmprunteur({ ...stepsDataEmprunteur, "informations-complementaires": data }));
        if (isStepDataValid()) {
            if (dataAdherents.length === 1) {
                if (parseInt(dataAdherents[0]["quotite_base"]) !== 100) {
                    handleDataAdherents(0, "quotite_base", 100);
                }
            }
            dispatch(changeIsButtonEnabled(true));
        } else {
            dispatch(changeIsButtonEnabled(false));
        }
    }, [data]);

    useEffect(() => {
        setData((prevState: any) => ({ ...prevState, lst_adherents: dataAdherents }));
    }, [dataAdherents]);


    useEffect(() => {
        if (isStepDataValid()) {
            dispatch(changeIsButtonEnabled(true));

        } else {
            dispatch(changeIsButtonEnabled(false));
        }
    }, [currentSubstep]);

    useEffect(() => {
        activeAdherentRef.current = activeAdherent;
    }, [activeAdherent]);

    useEffect(() => {
        activeRibRef.current = activeRib;
    }, [activeRib]);


    const handleDataAdherents = (index: number, key: string, value: any) => {
        setDataAdherents((prevState: any) => prevState.map((obj: any, i: number) => {
            if (i === index) {
                return {
                    ...obj,
                    [key]: value
                };
            }
            return obj;
        }));
    };

    const handleAdresseAdherent = (index: number, addressObject: { [key: string]: any }) => {
        const updatedDataAdherents = [...dataAdherents];
        if (index >= 0 && index < updatedDataAdherents.length) {
            for (const key in addressObject) {
                if (addressObject.hasOwnProperty(key)) {
                    updatedDataAdherents[index].adresse_actuelle = {
                        ...updatedDataAdherents[index].adresse_actuelle,
                        [key]: addressObject[key],
                    };
                }
            }
            handleDataAdherents(index, "adresse_actuelle", updatedDataAdherents[index].adresse_actuelle);
        }
    };

    const handleDataRib = (index: number, key: string, value: any) => {
        const updatedDataAdherents = [...dataAdherents];
        if (index >= 0 && index < updatedDataAdherents.length) {
            updatedDataAdherents[index].rib = {
                ...updatedDataAdherents[index].rib,
                [key]: value,
            };
            handleDataAdherents(index, "rib", updatedDataAdherents[index].rib);
        }
    };

    const handleSelectAdresse = (suggestion: any) => {
        const adresseObject = {
            adresse: suggestion.description,
            ville: suggestion.terms.length > 1 ? suggestion.terms[suggestion.terms.length - 2].value : suggestion.terms[0].value
        }
        handleAdresseAdherent(activeAdherentRef.current, adresseObject);
    };

    const handleSelectAdresseRib = (suggestion: any) => {
        handleDataRib(activeRibRef.current as number, "adresse", suggestion.description);
    };

    const isStepDataValid = () => {
        if (currentSubstep === 0) {
            return dataAdherents.every((adherent: any) => {
                return (
                    adherent["prenom"] !== "" && adherent["nom"] !== "" &&
                    phoneNumberRegex.test(adherent["telephone"]) && adherent["gender"] !== "" &&
                    adherent["date_naissance"] !== "" && emailRegEx.test(adherent["email"]) &&
                    adherent["pays_naissance"] !== "" && adherent["profession"] !== "" &&
                    adherent["adresse_actuelle"]["adresse"] !== "" && adherent["adresse_actuelle"]["adresse"] !== null &&
                    adherent["adresse_actuelle"]["ville"] !== "" && adherent["adresse_actuelle"]["ville"] !== null &&
                    adherent["ville_naissance"] !== ""
                )
            });
        }
        if (currentSubstep === 1) {
            return (
                dataAdherents.every((ad: any) => {
                    return (
                        ad["rib"]["iban"] && ad["rib"]["bic"] &&
                        ad["rib"]["type_rib"] !== "" &&
                        (ad["rib"]["type_rib"] === 3 ? (
                            ad["rib"]["forme_juridique"] && ad["rib"]["activite"] && ad["rib"]["siret"] && ad["rib"]["raison_sociale"]
                        ) : ad["rib"]["titulaire_compte"]) &&
                        ad["rib"]["adresse"] && ad["rib"]["ville_code_postal"] && ad["rib"]["pays_coordonnees"]
                    )
                })
            );
        }
    };


    return (
        <Stack spacing={2} mt={6}>
            {currentErreurMessage && (<Error error={currentErreurMessage} />)}
            {((): any => {
                if (currentSubstep === 0) {
                    return (
                        <Fade in={stepEmprunteur === 4} {...({ timeout: 1500 })}>
                            <Stack>
                                <Question question={questions[currentSubstep]} />
                                {
                                    dataAdherents?.length !== 1 && (
                                        <Stack width={"100%"} spacing={3}>
                                            <Stack direction="row" spacing={2} alignItems={"center"} justifyContent={"center"}>
                                                {
                                                    dataAdherents?.map((_ad: any, index: number) => (
                                                        <Chip key={index} label={index === 0 ? "Vous" : `${matches ? "" : "Adhérent"} ${index + 1}`}
                                                            className={activeAdherent === index ? 'chip-active' : "chip-inactive"}
                                                            variant={activeAdherent === index ? 'filled' : "outlined"}
                                                            onClick={() => setActiveAdherent(index)}
                                                        />
                                                    ))
                                                }
                                            </Stack>
                                            <Divider />
                                        </Stack>
                                    )
                                }
                                <Stack spacing={2}>
                                    <h3 className='century-bold'>Informations personnelles</h3>
                                    <Stack flexWrap={'wrap'} direction={'row'} columnGap={"35px"} rowGap={"18px"} alignItems={"end"}>
                                        <RadioGroup
                                            sx={{ columnGap: 3, rowGap: 1.5 }}
                                            row
                                            aria-labelledby="demo-row-radio-buttons-group-label"
                                            name="row-radio-buttons-group"
                                            onChange={(event: any) => handleDataAdherents(activeAdherent, "gender", event.target.value)}
                                        >
                                            <FormControlLabel className={"radio-item"} value="Homme" checked={(dataAdherents[activeAdherent]["gender"] === "Homme")} control={<Radio />} label="Homme" labelPlacement="start" />
                                            <FormControlLabel className={"radio-item"} value="Femme" checked={(dataAdherents[activeAdherent]["gender"] === "Femme")} control={<Radio />} label="Femme" labelPlacement="start" />
                                        </RadioGroup>
                                    </Stack>
                                    <Stack direction={'row'} gap={"10px"} width={"100%"} alignItems={"end"}>
                                        <FormControl fullWidth required>
                                            <Label label={"Prénom"} />
                                            <TextField onChange={(event: any) => handleDataAdherents(activeAdherent, "prenom", event.target.value)} variant="outlined" value={dataAdherents[activeAdherent]["prenom"]} />
                                        </FormControl>
                                        <FormControl fullWidth required>
                                            <Label label={"Nom"} />
                                            <TextField onChange={(event: any) => handleDataAdherents(activeAdherent, "nom", event.target.value)} variant="outlined" value={dataAdherents[activeAdherent]["nom"]} />
                                        </FormControl>
                                    </Stack>
                                    <Stack direction={'row'} gap={"10px"} width={"100%"} alignItems={"end"}>
                                        <FormControl fullWidth required>
                                            <Label label={"Email"} />
                                            <TextField onChange={(event: any) => handleDataAdherents(activeAdherent, "email", event.target.value)} variant="outlined" value={dataAdherents[activeAdherent]["email"]} />
                                        </FormControl>
                                        <FormControl fullWidth required>
                                            <Label label={"Nº de téléphone"} />
                                            <TextField onChange={(event: any) => handleDataAdherents(activeAdherent, "telephone", event.target.value)} variant="outlined" value={dataAdherents[activeAdherent]["telephone"]} />
                                        </FormControl>
                                    </Stack>
                                    <Stack direction={'row'} gap={"10px"} width={"100%"} alignItems={"start"}>
                                        <FormControl fullWidth required>
                                            <Label label={"Adresse actuelle"} />
                                            <GooglePlacesAutocomplete
                                                apiKey="AIzaSyBA1dplU9rdYSCSnwdrIFg_zuoaqcxW4Rc"
                                                placeholder="Indiquez un lieu"
                                                loader={<p className='century-bold' style={{ fontSize: 14 }}>Chargement des adresses...</p>}
                                                initialValue={dataAdherents[activeAdherent]["adresse_actuelle"]["adresse"] ?? ""}
                                                onSelect={handleSelectAdresse}
                                                renderSuggestions={(_active, suggestions, onSelectSuggestion) => (
                                                    <div className="suggestions-container">
                                                        {suggestions.map((suggestion, index) => (
                                                            <MenuItem key={index} onClick={(event) => onSelectSuggestion(suggestion, event)}>
                                                                {suggestion.description}
                                                            </MenuItem>
                                                        ))}
                                                    </div>
                                                )}
                                            />
                                        </FormControl>
                                        <FormControl fullWidth required>
                                            <Label label={"Profession"} />
                                            <Select
                                                labelId="demo-simple-select-label"
                                                onChange={(event: any) => handleDataAdherents(activeAdherent, "profession", event.target.value)}
                                                input={<OutlinedInput value={dataAdherents[activeAdherent]["profession"]} />}
                                            >
                                                {
                                                    lstProfession?.map((pn: any, index: number) => (
                                                        <MenuItem value={pn} key={index}>{pn}</MenuItem>
                                                    ))
                                                }
                                            </Select>
                                        </FormControl>
                                    </Stack>
                                </Stack>
                                <Stack spacing={2}>
                                    <h3 className='century-bold'>Informations de naissance</h3>
                                    <Stack direction={'row'} gap={"10px"} width={"100%"} alignItems={"end"}>
                                        <FormControl fullWidth required>
                                            <Label label={"Date de naissance"} />
                                            <DatePicker value={dayjs(dataAdherents[activeAdherent]["date_naissance"]) ?? ""}
                                                onChange={(value: any) => handleDataAdherents(activeAdherent, "date_naissance", moment(value.toString()).format("YYYY-MM-DD"))}
                                            />
                                        </FormControl>
                                        <FormControl fullWidth required>
                                            <Label label={"Pays de naissance"} />
                                            <Select
                                                labelId="demo-simple-select-label"
                                                onChange={(event: any) => handleDataAdherents(activeAdherent, "pays_naissance", event.target.value)}
                                                input={<OutlinedInput value={dataAdherents[activeAdherent]["pays_naissance"]} />}
                                            >
                                                {
                                                    lstPays?.map((pn: any, index: number) => (
                                                        <MenuItem value={pn} key={index}>{pn}</MenuItem>
                                                    ))
                                                }
                                            </Select>
                                        </FormControl>
                                    </Stack>
                                    <FormControl fullWidth required>
                                        <Label label={"Ville de naissance"} />
                                        <TextField onChange={(event: any) => handleDataAdherents(activeAdherent, "ville_naissance", event.target.value)} variant="outlined" value={dataAdherents[activeAdherent]["ville_naissance"]} />
                                    </FormControl>
                                </Stack>
                            </Stack>
                        </Fade>
                    )
                }
                if (currentSubstep === 1) {
                    return (
                        <Grow in={stepEmprunteur === 4} {...({ timeout: 1000 })}>
                            <Stack>
                                <Question question={questions[currentSubstep]} />
                                {
                                    dataAdherents?.map((ad: any, index: number) => (
                                        activeRib === index ? (
                                            <Stack width={"100%"} className='form-section' mt={3} key={index}>
                                                <Stack p={5} spacing={2}>
                                                    <Stack direction={'row'} gap={"10px"} width={"100%"} alignItems={"end"}>
                                                        <FormControl fullWidth required>
                                                            <Label label={"IBAN"} />
                                                            <OutlinedInput placeholder='FR76 3000 1007 9412 3456 7890 185' onChange={(event: any) => handleDataRib(index, "iban", event.target.value)} value={ad["rib"]["iban"] ?? ""} />
                                                        </FormControl>
                                                        <FormControl fullWidth required>
                                                            <Label label={"BIC"} />
                                                            <OutlinedInput onChange={(event: any) => handleDataRib(index, "bic", event.target.value)} value={ad["rib"]["bic"] ?? ""} />
                                                        </FormControl>
                                                    </Stack>
                                                    <Stack direction={'row'} gap={"10px"} width={"100%"} alignItems={"end"}>
                                                        <FormControl fullWidth required>
                                                            <Label label={"Type de rib"} />
                                                            <Select
                                                                labelId="demo-simple-select-label"
                                                                onChange={(event: any) => handleDataRib(index, "type_rib", lstTypeRib?.findIndex((rb: any) => rb.value === event.target.value) + 1)}
                                                                input={<OutlinedInput value={lstTypeRib[parseInt(ad["rib"]["type_rib"]) - 1]?.value ?? ""} />}
                                                            >
                                                                {
                                                                    lstTypeRib?.map((pn: any, index: number) => (
                                                                        <MenuItem value={pn.value} key={index}>{pn.value}</MenuItem>
                                                                    ))
                                                                }
                                                            </Select>
                                                        </FormControl>
                                                        {
                                                            ad["rib"]["type_rib"] === 3 ? (
                                                                <FormControl fullWidth required>
                                                                    <Label label={"Forme juridique"} />
                                                                    <Select
                                                                        labelId="demo-simple-select-label"
                                                                        onChange={(event: any) => handleDataRib(index, "forme_juridique", lstFormeJuridique?.findIndex((rb: any) => rb.value === event.target.value) + 1)}
                                                                        input={<OutlinedInput value={lstFormeJuridique[parseInt(ad["rib"]["forme_juridique"]) - 1]?.value ?? ""} />}
                                                                    >
                                                                        {
                                                                            lstFormeJuridique?.map((pn: any, index: number) => (
                                                                                <MenuItem value={pn.value} key={index}>{pn.value}</MenuItem>
                                                                            ))
                                                                        }
                                                                    </Select>
                                                                </FormControl>
                                                            ) : (
                                                                <FormControl fullWidth required>
                                                                    <Label label={"Titulaire de compte"} />
                                                                    <OutlinedInput onChange={(event: any) => handleDataRib(index, "titulaire_compte", event.target.value)} value={ad["rib"]["titulaire_compte"] ?? ""} />
                                                                </FormControl>
                                                            )
                                                        }
                                                    </Stack>
                                                    {
                                                        ad["rib"]["type_rib"] === 3 && (
                                                            <>
                                                                <Stack direction={'row'} gap={"10px"} width={"100%"} alignItems={"end"}>
                                                                    <FormControl fullWidth required>
                                                                        <Label label={"Raison sociale"} />
                                                                        <OutlinedInput onChange={(event: any) => handleDataRib(index, "raison_sociale", event.target.value)} value={ad["rib"]["raison_sociale"] ?? ""} />
                                                                    </FormControl>
                                                                    <FormControl fullWidth required>
                                                                        <Label label={"SIRET"} />
                                                                        <OutlinedInput placeholder="000 000 000 00000" onChange={(event: any) => handleDataRib(index, "siret", event.target.value)} value={ad["rib"]["siret"] ?? ""} />
                                                                    </FormControl>
                                                                </Stack>
                                                                <FormControl fullWidth required>
                                                                    <Label label={"Activité (Code NAF ou APE)"} />
                                                                    <OutlinedInput onChange={(event: any) => handleDataRib(index, "activite", event.target.value)} value={ad["rib"]["activite"] ?? ""} />
                                                                </FormControl>
                                                            </>
                                                        )
                                                    }
                                                    <Stack direction={'row'} gap={"10px"} width={"100%"} alignItems={"start"}>
                                                        <FormControl fullWidth required>
                                                            <Label label={"Adresse"} />
                                                            {/* <OutlinedInput placeholder='Indiquez un lieu' onChange={(event: any) => handleDataRib(index, "adresse", event.target.value)} value={ad["rib"]["adresse"] ?? ""} /> */}
                                                            <GooglePlacesAutocomplete
                                                                apiKey="AIzaSyBA1dplU9rdYSCSnwdrIFg_zuoaqcxW4Rc"
                                                                placeholder="Indiquez un lieu"
                                                                loader={<p className='century-bold' style={{ fontSize: 14 }}>Chargement des adresses...</p>}
                                                                initialValue={ad["rib"]["adresse"] ?? ""}
                                                                onSelect={handleSelectAdresseRib}
                                                                inputClassName="rib-adresse-autocomplete__input"
                                                                renderSuggestions={(_active, suggestions, onSelectSuggestion) => (
                                                                    <div className="suggestions-container">
                                                                        {suggestions.map((suggestion, index) => (
                                                                            <MenuItem key={index} onClick={(event) => onSelectSuggestion(suggestion, event)}>
                                                                                {suggestion.description}
                                                                            </MenuItem>
                                                                        ))}
                                                                    </div>
                                                                )}
                                                            />
                                                        </FormControl>
                                                        <FormControl fullWidth required>
                                                            <Label label={"Ville code postal"} />
                                                            <OutlinedInput onChange={(event: any) => handleDataRib(index, "ville_code_postal", event.target.value)} value={ad["rib"]["ville_code_postal"] ?? ""} />
                                                        </FormControl>
                                                    </Stack>
                                                    <FormControl fullWidth required>
                                                        <Label label={"Pays coordonnées bancaire"} />
                                                        <Select
                                                            labelId="demo-simple-select-label"
                                                            onChange={(event: any) => handleDataRib(index, "pays_coordonnees", event.target.value)}
                                                            input={<OutlinedInput value={ad["rib"]["pays_coordonnees"] ?? ""} />}
                                                        >
                                                            {
                                                                lstPays?.map((pn: any, index: number) => (
                                                                    <MenuItem value={pn} key={index}>{pn}</MenuItem>
                                                                ))
                                                            }
                                                        </Select>
                                                    </FormControl>
                                                </Stack>
                                            </Stack>
                                        ) : (
                                            <Stack width={"100%"} className='form-section' mt={3} key={index}>
                                                <Stack p={4}>
                                                    <Stack direction={"row"} alignItems={"center"} spacing={1} justifyContent={"space-between"}>
                                                        <Stack direction={"row"} alignItems={"center"} gap={1}>
                                                            <PiBankLight style={{ fontSize: 30, color: colors.blue1 }} />
                                                            <p className='m-0 century' style={{ fontSize: 17 }}> RIB de {ad["prenom"]} {ad["nom"]}</p>
                                                        </Stack>
                                                        <Stack direction={"row"} alignItems={"center"} spacing={1}>
                                                            <RiEditBoxLine className='cursor-pointer' onClick={() => setActiveRib(index)} style={{ fontSize: 30, color: "#aaa8a1" }} />
                                                        </Stack>
                                                    </Stack>
                                                </Stack>
                                            </Stack>
                                        )
                                    ))
                                }
                            </Stack>
                        </Grow>
                    )
                }
            })()}
        </Stack>
    )
};